export default __webpack_public_path__ + "static/media/contactar_activado.4ac90088.svg";